<section class="px-4 py-8 md:mt-12 h-auto dark:text-white" [dir]="languageDirection">
  <!-- <div class="container mt-16 max-w-4xl p-6">
    <h1 class="text-4xl">Terms and Conditions</h1>

    <h1 class="text-4xl">Preamble</h1>
    <p class="text-gray-600 dark:text-white mt-4">
      Almanjobs supports organizations in all areas that deal with the people in that organization. Almanjob's goal is to help organizations focus on their core purpose so that they can be successful in the long term.
    </p>
    <p>Almanjobs UG therefore offers sokutions for recruiting new employees but also solutions for .
    </p>
  </div> -->

  <div class="flex flex-col gap-16">
    <div [innerHTML]="'TERMS-AND-CONDITIONS.PARAGRAPH0' | translate"></div>
    <div [innerHTML]="'TERMS-AND-CONDITIONS.PARAGRAPH1' | translate"></div>
    <div [innerHTML]="'TERMS-AND-CONDITIONS.PARAGRAPH2' | translate"></div>
    <div [innerHTML]="'TERMS-AND-CONDITIONS.PARAGRAPH3' | translate"></div>
    <div [innerHTML]="'TERMS-AND-CONDITIONS.PARAGRAPH4' | translate"></div>
    <div [innerHTML]="'TERMS-AND-CONDITIONS.PARAGRAPH5' | translate"></div>
    <div [innerHTML]="'TERMS-AND-CONDITIONS.PARAGRAPH6' | translate"></div>
    <div [innerHTML]="'TERMS-AND-CONDITIONS.PARAGRAPH7' | translate"></div>
    <div [innerHTML]="'TERMS-AND-CONDITIONS.PARAGRAPH8' | translate"></div>
    <div [innerHTML]="'TERMS-AND-CONDITIONS.PARAGRAPH9' | translate"></div>
  </div>
</section>
